module.exports = __webpack_public_path__ + "img/redacao_pendente.1a835739.svg";